// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SId0wcbAjkaepfLkTfYN {
    padding: 5px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: background-color 0.2s, transform 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f9f9f9;
    color: #333;
    margin-bottom: 5px;
    margin-top: 5px;
}

.SId0wcbAjkaepfLkTfYN:hover {
    background-color: #e6e6e6;
}

.SId0wcbAjkaepfLkTfYN:active {
    background-color: #ddd;
}

.MU_gvfpcteQOzzsW7Eoa {
    background-color: #f0f0f0;
    border-color: #999;
}

.MU_gvfpcteQOzzsW7Eoa::after {
    font-size: 18px;
}

.V1P1M46M4VokXqDC4b28 {
    background-color: #f9f9f9;
    border-color: #ccc;
}

.V1P1M46M4VokXqDC4b28::after {
    font-size: 18px;
}

.k91LeXLVSFaos1b_2UgT {
    margin-left: 5px;
}

/* Подсветка только лейбла AMO-поля */
._cCDO_Df0u2d4sIORhCw .linked-form__field__label {
    color: red !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChecklistInLeadCard/checklist.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iDAAiD;IACjD,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,qBAAqB;AACzB","sourcesContent":[".checklistHeader {\n    padding: 5px;\n    font-size: 15px;\n    font-weight: 500;\n    cursor: pointer;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    transition: background-color 0.2s, transform 0.2s;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #f9f9f9;\n    color: #333;\n    margin-bottom: 5px;\n    margin-top: 5px;\n}\n\n.checklistHeader:hover {\n    background-color: #e6e6e6;\n}\n\n.checklistHeader:active {\n    background-color: #ddd;\n}\n\n.open {\n    background-color: #f0f0f0;\n    border-color: #999;\n}\n\n.open::after {\n    font-size: 18px;\n}\n\n.closed {\n    background-color: #f9f9f9;\n    border-color: #ccc;\n}\n\n.closed::after {\n    font-size: 18px;\n}\n\n.subItem {\n    margin-left: 5px;\n}\n\n/* Подсветка только лейбла AMO-поля */\n.invalidField :global(.linked-form__field__label) {\n    color: red !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checklistHeader": `SId0wcbAjkaepfLkTfYN`,
	"open": `MU_gvfpcteQOzzsW7Eoa`,
	"closed": `V1P1M46M4VokXqDC4b28`,
	"subItem": `k91LeXLVSFaos1b_2UgT`,
	"invalidField": `_cCDO_Df0u2d4sIORhCw`
};
export default ___CSS_LOADER_EXPORT___;
